var render = function render(){
  var _vm$billingaccount_sa, _vm$billingaccount_sa2, _vm$billingaccount_sa3, _vm$billingaccount_sa4, _vm$billingaccount_sa5, _vm$billingaccount_sa6, _vm$billingaccount_sa7, _vm$billingaccount_sa8, _vm$billingaccount_sa9, _vm$billingaccount_sa10, _vm$billingaccount_sa11, _vm$billingaccount_sa12, _vm$billingaccount_sa13, _vm$billingaccount_sa14, _vm$billingaccount_sa15;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": "",
      "help-content-id": "popup-billingaccount"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("title")))]), _vm.billingaccount ? _c('template', {
    slot: "content"
  }, [_c('Info', {
    attrs: {
      "elevation": 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("instructions")) + " ")]), _c('h6', {
    staticClass: "stitch-modal__title"
  }, [_vm._v("Information")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "autofocus": "",
      "error-messages": (_vm$billingaccount_sa = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa === void 0 ? void 0 : _vm$billingaccount_sa.siren,
      "label": _vm.$translate('siren'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.siren,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount, "siren", $$v);
      },
      expression: "billingaccount.siren"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "label": _vm.$translate('legal_structure'),
      "error-messages": _vm.billingaccount_saving_errors.legal_structure,
      "items": _vm.$utils.getLegalStructureItems(),
      "value": _vm.getLegalStructure(_vm.billingaccount.legal_structure),
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function input($event) {
        _vm.billingaccount.legal_structure = $event;
      }
    }
  })], 1), _vm.$utils.shareCapitalRequired(_vm.billingaccount.legal_structure) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "error-messages": (_vm$billingaccount_sa2 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa2 === void 0 ? void 0 : _vm$billingaccount_sa2.share_capital,
      "label": _vm.$translate('share_capital'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.share_capital,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount, "share_capital", $$v);
      },
      expression: "billingaccount.share_capital"
    }
  })], 1) : _vm._e()], 1), _c('h6', {
    staticClass: "stitch-modal__title"
  }, [_vm._v(" " + _vm._s(_vm.$translate("address")) + " ")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "error-messages": (_vm$billingaccount_sa3 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa3 === void 0 ? void 0 : _vm$billingaccount_sa3.name,
      "label": _vm.$translate('legalName'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.name,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount, "name", $$v);
      },
      expression: "billingaccount.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-combobox', {
    staticClass: "pt-0",
    attrs: {
      "multiple": "",
      "clearable": "",
      "label": _vm.$translate('emails'),
      "dense": "",
      "deletable-chips": "",
      "error-messages": (_vm$billingaccount_sa4 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa4 === void 0 ? void 0 : (_vm$billingaccount_sa5 = _vm$billingaccount_sa4.address) === null || _vm$billingaccount_sa5 === void 0 ? void 0 : _vm$billingaccount_sa5.emails,
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate('emails')))]), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('emailHint')
          }
        })];
      },
      proxy: true
    }], null, false, 4030372233),
    model: {
      value: _vm.billingaccount.address.emails,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount.address, "emails", $$v);
      },
      expression: "billingaccount.address.emails"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "error-messages": (_vm$billingaccount_sa6 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa6 === void 0 ? void 0 : (_vm$billingaccount_sa7 = _vm$billingaccount_sa6.address) === null || _vm$billingaccount_sa7 === void 0 ? void 0 : _vm$billingaccount_sa7.line1,
      "label": _vm.$translate('line1'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.address.line1,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount.address, "line1", $$v);
      },
      expression: "billingaccount.address.line1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "error-messages": (_vm$billingaccount_sa8 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa8 === void 0 ? void 0 : (_vm$billingaccount_sa9 = _vm$billingaccount_sa8.address) === null || _vm$billingaccount_sa9 === void 0 ? void 0 : _vm$billingaccount_sa9.line2,
      "label": _vm.$translate('line2'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.address.line2,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount.address, "line2", $$v);
      },
      expression: "billingaccount.address.line2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "error-messages": (_vm$billingaccount_sa10 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa10 === void 0 ? void 0 : (_vm$billingaccount_sa11 = _vm$billingaccount_sa10.address) === null || _vm$billingaccount_sa11 === void 0 ? void 0 : _vm$billingaccount_sa11.city,
      "label": _vm.$translate('city'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount.address, "city", $$v);
      },
      expression: "billingaccount.address.city"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": (_vm$billingaccount_sa12 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa12 === void 0 ? void 0 : (_vm$billingaccount_sa13 = _vm$billingaccount_sa12.address) === null || _vm$billingaccount_sa13 === void 0 ? void 0 : _vm$billingaccount_sa13.postal_code,
      "label": _vm.$translate('postalCode'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.address.postal_code,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount.address, "postal_code", $$v);
      },
      expression: "billingaccount.address.postal_code"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": (_vm$billingaccount_sa14 = _vm.billingaccount_saving_errors) === null || _vm$billingaccount_sa14 === void 0 ? void 0 : (_vm$billingaccount_sa15 = _vm$billingaccount_sa14.address) === null || _vm$billingaccount_sa15 === void 0 ? void 0 : _vm$billingaccount_sa15.country,
      "label": _vm.$translate('country'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.billingaccount.address.country,
      callback: function callback($$v) {
        _vm.$set(_vm.billingaccount.address, "country", $$v);
      },
      expression: "billingaccount.address.country"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('template', {
    slot: "bottom"
  }, [!_vm.is_readonly ? [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "ghost": "",
      "text": _vm.$translate('cancel')
    },
    on: {
      "click": _vm.hideModal
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.$translate('continue'),
      "disabled": !_vm.canSave || _vm.billingaccount_saving,
      "loading": _vm.billingaccount_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  })] : [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "ghost": "",
      "text": _vm.$translate('close')
    },
    on: {
      "click": _vm.hideModal
    }
  })]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }